<template>
  <div class="page-content no-margin">
    <el-dialog :visible.sync="open" max-width="40%" :before-close="close" class="no-margin" >
      <div class="no-margin">
        <div class="navbar no-margin">
          <div class="nav-item" :class="{ active: activeTab === 'NPS' }" @click="activeTab = 'NPS'">NPS</div>
          <div class="nav-item" :class="{ active: activeTab === 'Comments' }" @click="activeTab = 'Comments'">
            Comment(s)
          </div>
        </div>
        <div class="content no-margin">
          <surveys-ui-stats-nps v-if="activeTab === 'NPS'" :stats="stats" :id="id"/>
          <surveys-ui-stats-comments v-if="activeTab === 'Comments'" :id="id"/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SurveyStats',

  props: {
    open: {
      type: Boolean,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      loaded: false,
      chart: null,
      stats: [],
      activeTab: 'NPS' // Default active tab
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('surveys', {
      getById: 'getById',
      getStats: 'getStatsById'
    })
  },

  methods: {
    ...mapActions('surveys', ['loadSurveys', 'loadSurveyStats']),

    init() {
      if (this.getStats(this.id)) {
        this.loaded = true
        this.stats = this.getStats(this.id)
        return
      }
      const startDate = new Date()
      startDate.setMonth(startDate.getMonth() - 12)
      const endDate = new Date()
      this.loadSurveyStats({ surveyId: this.id, startDate, endDate }).then(stats => {
        this.loaded = true

        if (!stats || stats.length === 0) {
          return
        }

        stats.sort((a, b) => {
          const dateA = new Date(a.year, a.month - 1)
          const dateB = new Date(b.year, b.month - 1)
          return dateA - dateB
        })

        this.stats = stats
      })
    }
  },
  mounted() {
    this.init()
  },

}
</script>

<style>

.page-content {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-top: 0px !important;
}

.title {
  text-align: center;
  margin-bottom: 20px;
}

.navbar {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.nav-item {
  cursor: pointer;
  margin-right: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #555;
}

.nav-item.active {
  color: #000;
}

.content {
  text-align: center;
}

.no-stats-message {
  margin-top: 20px;
  color: #999;
}

.no-margin {
  text-align: center;
}

.no-margin .el-dialog {
  display: inline-block;
  margin-top: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/ui/modal/stats.vue